import { render, staticRenderFns } from "./MealAdd.vue?vue&type=template&id=159eb510&scoped=true&"
import script from "./MealAdd.vue?vue&type=script&lang=js&"
export * from "./MealAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159eb510",
  null
  
)

/* custom blocks */
import block0 from "./MealAdd.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports